// client/menu-items/CopySelectionToClipboard.ts
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { baseKeymap } from "prosemirror-commands";
import { DOMParser } from "prosemirror-model";
import "prosemirror-state";
var CopySelectionMenuItem = {
  label: "Kopieren",
  icon: "content_copy",
  run: async (view) => {
    console.log(baseKeymap);
    try {
      view.focus();
      const success = document.execCommand("copy");
      if (success) {
        await XDialog.alert("Der ausgew\xE4hlte Inhalt wurde in die Zwischenablage kopiert.");
      } else {
        await XDialog.alert("Fehler beim Kopieren in die Zwischenablage.");
      }
    } catch (err) {
      if (err instanceof Error)
        await XDialog.alert("Fehler beim Kopieren: " + err.message);
    }
  },
  shouldVisualize: (view) => {
    return !view.state.selection.empty;
  }
};
var PasteFromClipboardMenuItem = {
  label: "Einf\xFCgen",
  icon: "arrow_upward",
  run: async (view) => {
    const { state, dispatch } = view;
    const { tr, schema } = state;
    try {
      if (!navigator.clipboard || !navigator.clipboard.read) {
        console.error("Die Zwischenablage-API wird in diesem Browser nicht unterst\xFCtzt.");
        return;
      }
      const clipboardItems = await navigator.clipboard.read();
      let htmlContent = null;
      for (const item of clipboardItems) {
        if (item.types.includes("text/html")) {
          const blob = await item.getType("text/html");
          htmlContent = await blob.text();
          break;
        }
      }
      if (!htmlContent) {
        console.warn("Die Zwischenablage enth\xE4lt keinen HTML-Inhalt.");
        return;
      }
      const tempElement = document.createElement("div");
      tempElement.innerHTML = htmlContent;
      const fragment = DOMParser.fromSchema(schema).parse(tempElement);
      tr.replaceSelectionWith(fragment);
      dispatch(tr);
    } catch (error) {
      console.error("Fehler beim Einf\xFCgen aus der Zwischenablage:", error);
    }
  },
  shouldVisualize: (view) => {
    return navigator.clipboard && typeof navigator.clipboard.read === "function";
  }
};
export {
  CopySelectionMenuItem,
  PasteFromClipboardMenuItem
};
